import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Export API URL and base URL (without /api) for file paths
export const getApiUrl = () => API_URL;
export const getBaseUrl = () => API_URL.replace('/api', '');

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to add the auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    toast.error('Request failed. Please try again.');
    return Promise.reject(error);
  }
);

// Add a response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config?.skipErrorHandler) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      toast.error('Session expired. Please login again.');
      // You might want to redirect to login page here
      window.location.href = '/login';
    } else if (error.response?.status === 403) {
      toast.error(error.response?.data?.message || 'You do not have permission to perform this action.');
    } else if (error.response?.status === 400) {
      toast.error(error.response?.data?.message || 'Server action error');
    } else if (error.response?.status === 404) {
      toast.error(error.response?.data?.message || 'Resource not found.');
    } else if (error.response?.status === 500) {
      toast.error(error.response?.data?.message || 'Server error. Please try again later.');
    } else if (!error.response && error.request) {
      toast.error('Network error. Please check your connection.');
    } else {
      toast.error('An unexpected error occurred.');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
